__turbopack_context__.v({
  "cta": "CardCTA-module-scss-module__ruaGGq__cta",
  "ctaInner": "CardCTA-module-scss-module__ruaGGq__ctaInner",
  "headline": "CardCTA-module-scss-module__ruaGGq__headline",
  "iconWrapper": "CardCTA-module-scss-module__ruaGGq__iconWrapper",
  "landscapeCTA": "CardCTA-module-scss-module__ruaGGq__landscapeCTA",
  "landscapeCTAInner": "CardCTA-module-scss-module__ruaGGq__landscapeCTAInner",
});
